import { useMediaQuery, useTheme } from '@mui/material';

const mapSizeByBreakpoint = {
  sm: 220,
  md: 380,
  lg: 500,
} as const;

export const useClickAndCollectMapSize = () => {
  const theme = useTheme();

  const isLgUp = useMediaQuery(theme.breakpoints.up('lg'));
  const isMdUp = useMediaQuery(theme.breakpoints.up('md'));
  const isSmUp = useMediaQuery(theme.breakpoints.up('sm'));

  if (isLgUp) {
    return mapSizeByBreakpoint.lg;
  }
  if (isMdUp) {
    return mapSizeByBreakpoint.md;
  }
  if (isSmUp) {
    return mapSizeByBreakpoint.sm;
  }

  return mapSizeByBreakpoint.sm; // xs fallback
};
